import { Space } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import {
    bindPendingChatContext,
    peekPendingChatContext,
} from "../components/MetadataDocuments/services/pendingChatContext";
import { db } from "../db";
import { useChatId } from "../hooks/useChatId";
import { ChatRouteChild } from "./ChatRoute";

interface ChatRouteProps {
    hideHeader?: boolean;
    isCompact?: boolean;
}

export function ChatRoute({ hideHeader, isCompact }: ChatRouteProps = {}) {
    const navigate = useNavigate();
    const chatId = useChatId();
    const [pendingContext] = useState(() => peekPendingChatContext());

    useEffect(() => {
        if (window.location.hash === "#/") {
            navigate({ to: "/" });
        }
    }, [navigate]);

    useEffect(() => {
        if (chatId && pendingContext && !pendingContext.boundChatId) {
            bindPendingChatContext(chatId.toString());
        }
    }, [chatId, pendingContext]);

    const contextChatId = pendingContext?.boundChatId;
    const contextApplies = Boolean(
        pendingContext && (!contextChatId || contextChatId === chatId?.toString()),
    );
    const activeContext = contextApplies ? pendingContext : undefined;

    const messages = useLiveQuery(() => {
        if (!chatId) return [];
        return db.messages.where("chatId").equals(chatId).sortBy("createdAt");
    }, [chatId]);

    return (
        <>
            {!isCompact && <Space h="lg" />}
            <ChatRouteChild
                chatId={chatId ?? undefined}
                messages={messages}
                hideHeader={hideHeader}
                isCompact={isCompact}
                contextTags={activeContext?.contextTags}
                metadataFilter={activeContext?.metadataFilter}
                fixedDatasources={activeContext?.datasources}
                fixedDatasourceLabel={activeContext?.datasourceLabel}
            />
        </>
    );
}
